import React, { useMemo } from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';

const FormItem = Form.Item;
const Option = Select.Option;

const defaultRules = [
  {
    required: true,
    message: '课程顾问不能为空',
  },
];

const AdvisorFormItem = (props) => {
  const {
    form,
    fetchAdvisorList,
    advisorList = [],
    itemStyle,
    includeNone,
    includeInactive,
    label = '课程顾问',
    placeholder = '顾问选择',
    noneLabel = '无',
    noneValue = 'NONE',
  } = props;
  let layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  let rules = props.rules ? props.rules : defaultRules;
  const displayAdvisorList = useMemo(
    () =>
      includeInactive
        ? advisorList
        : advisorList.filter((item) => item.isActive !== false),
    [advisorList, includeInactive]
  );

  return (
    <FormItem
      label={label}
      {...layouts}
      name='course_advisor'
      rules={rules}
      form={form}
    >
      <Select
        mode='single'
        showSearch
        optionFilterProp='children'
        filterOption={(input, option) =>
          String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onFocus={fetchAdvisorList}
        style={itemStyle}
        placeholder={placeholder}
        allowClear
        onSelect={(v) => {
          form.setFieldsValue({ course_advisor: v });
        }}
      >
        {includeNone && (
          <Option value={noneValue} key={noneValue}>
            {noneLabel}
          </Option>
        )}
        {displayAdvisorList.map((item) => {
          return (
            <Option value={item._id} key={item._id}>
              {item.cnname || item.name}
            </Option>
          );
        })}
      </Select>
    </FormItem>
  );
};

export default AdvisorFormItem;
